module.exports = __webpack_public_path__ + "static/media/carlos.27404ce2.jpg";